import styles from "./EventLabel.module.css";

export const EventLabel = ({ startDate, endDate }) => {
  const dates = [];
  if (startDate) dates.push(startDate);
  if (endDate) dates.push(endDate);

  return (
    <div className={styles.eventLabel}>
      {dates.map((date) => (
        <div key={date} className={styles.date}>
          {date.map((v) => (
            <div key={v}>{v}</div>
          ))}
        </div>
      ))}
    </div>
  );
};
